var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatacard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6512 23.1395H9.34884C5.24651 23.1395 4 21.893 4 17.7907V10.3488C4 6.24651 5.24651 5 9.34884 5H18.6512C22.7535 5 24 6.24651 24 10.3488V17.7907C24 21.893 22.7535 23.1395 18.6512 23.1395ZM9.34884 6.39535C6.0186 6.39535 5.39535 7.02791 5.39535 10.3488V17.7907C5.39535 21.1116 6.0186 21.7442 9.34884 21.7442H18.6512C21.9814 21.7442 22.6047 21.1116 22.6047 17.7907V10.3488C22.6047 7.02791 21.9814 6.39535 18.6512 6.39535H9.34884Z",
    fill: "url(#paint0_linear_2256_121396)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5114 11.0457H15.8603C15.4789 11.0457 15.1626 10.7295 15.1626 10.3481C15.1626 9.96667 15.4789 9.65039 15.8603 9.65039H20.5114C20.8928 9.65039 21.2091 9.96667 21.2091 10.3481C21.2091 10.7295 20.8928 11.0457 20.5114 11.0457Z",
    fill: "url(#paint1_linear_2256_121396)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5114 14.7674H16.7904C16.4091 14.7674 16.0928 14.4511 16.0928 14.0697C16.0928 13.6883 16.4091 13.3721 16.7904 13.3721H20.5114C20.8928 13.3721 21.2091 13.6883 21.2091 14.0697C21.2091 14.4511 20.8928 14.7674 20.5114 14.7674Z",
    fill: "url(#paint2_linear_2256_121396)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5118 18.4881H18.6513C18.2699 18.4881 17.9536 18.1718 17.9536 17.7904C17.9536 17.4091 18.2699 17.0928 18.6513 17.0928H20.5118C20.8931 17.0928 21.2094 17.4091 21.2094 17.7904C21.2094 18.1718 20.8931 18.4881 20.5118 18.4881Z",
    fill: "url(#paint3_linear_2256_121396)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7447 14.1065C9.43305 14.1065 8.36328 13.0368 8.36328 11.7251C8.36328 10.4135 9.43305 9.34375 10.7447 9.34375C12.0563 9.34375 13.126 10.4135 13.126 11.7251C13.126 13.0368 12.0563 14.1065 10.7447 14.1065ZM10.7447 10.7391C10.2051 10.7391 9.75863 11.1856 9.75863 11.7251C9.75863 12.2647 10.2051 12.7112 10.7447 12.7112C11.2842 12.7112 11.7307 12.2647 11.7307 11.7251C11.7307 11.1856 11.2842 10.7391 10.7447 10.7391Z",
    fill: "url(#paint4_linear_2256_121396)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 18.7954C13.6463 18.7954 13.3393 18.5257 13.3021 18.1629C13.1998 17.1582 12.3905 16.3489 11.3765 16.2559C10.9486 16.2187 10.5207 16.2187 10.0928 16.2559C9.07883 16.3489 8.26953 17.1489 8.16721 18.1629C8.13 18.5443 7.78581 18.8326 7.40442 18.7861C7.02302 18.7489 6.74395 18.4047 6.78116 18.0233C6.9486 16.3489 8.27883 15.0187 9.96256 14.8698C10.4742 14.8233 10.9951 14.8233 11.5067 14.8698C13.1811 15.028 14.5207 16.3582 14.6881 18.0233C14.7253 18.4047 14.4463 18.7489 14.0649 18.7861C14.0463 18.7954 14.0184 18.7954 13.9998 18.7954Z",
    fill: "url(#paint5_linear_2256_121396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2256_121396",
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 23.1395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2256_121396",
    x1: 18.1859,
    y1: 9.65039,
    x2: 18.1859,
    y2: 11.0457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2256_121396",
    x1: 18.6509,
    y1: 13.3721,
    x2: 18.6509,
    y2: 14.7674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2256_121396",
    x1: 19.5815,
    y1: 17.0928,
    x2: 19.5815,
    y2: 18.4881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2256_121396",
    x1: 10.7447,
    y1: 9.34375,
    x2: 10.7447,
    y2: 14.1065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2256_121396",
    x1: 10.7346,
    y1: 14.835,
    x2: 10.7346,
    y2: 18.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacard);
export default __webpack_public_path__ + "static/media/datacard.bb9e0bce3f39ab331f8f668a9e98ab55.svg";
export { ForwardRef as ReactComponent };